var _path, _path2, _g, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_285)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#2B6EC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 74.3168V72.3182H18.0433V74.3168H14.956V82.5H12.5298V74.3168H9.4375ZM21.736 72.3182L23.5953 75.5348H23.6749L25.5542 72.3182H28.3084L25.236 77.4091L28.4078 82.5H25.584L23.6749 79.2486H23.5953L21.6863 82.5H18.8823L22.0392 77.4091L18.9618 72.3182H21.736ZM29.248 74.3168V72.3182H37.8539V74.3168H34.7665V82.5H32.3404V74.3168H29.248Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 34H53V40.4721H51.9248L50.7256 36.3029C50.6429 35.9853 50.5464 35.7603 50.4361 35.6279C50.3534 35.4691 50.1742 35.3765 49.8985 35.35C49.6228 35.2971 49.1541 35.2706 48.4925 35.2706H43.8196V57.7838C43.8196 58.7103 43.8609 59.2529 43.9436 59.4118C44.0263 59.5706 44.2882 59.6765 44.7293 59.7294L47.0038 59.9676V61H37.0376V59.9676L39.312 59.7294C39.7531 59.6765 40.015 59.5706 40.0977 59.4118C40.1805 59.2529 40.2218 58.7103 40.2218 57.7838V35.2706H35.5075C34.8734 35.2706 34.4048 35.2971 34.1015 35.35C33.8258 35.3765 33.6328 35.4691 33.5226 35.6279C33.4398 35.7603 33.3571 35.9853 33.2744 36.3029L32.0752 40.4721H31V34Z",
    fill: "#2B6EC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTxt);
export default __webpack_public_path__ + "static/media/ico_txt.8d4ca7b021f903297dc400baa4dcc231.svg";
export { ForwardRef as ReactComponent };